import {inject, Injectable, Injector} from '@angular/core';
import {PreloadingStrategy, Route} from '@angular/router';
import {catchError, EMPTY, Observable, switchMap} from 'rxjs';
import {NavService} from './nav.service';
import {TokenService} from './token.service';
import {SettingsMenuItemType} from '../types/generated/settingsMenuItemType';

@Injectable({providedIn: 'root'})
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  private readonly injector: Injector = inject(Injector);
  private readonly tokenService: TokenService = inject(TokenService);

  public preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const preload = route.data?.['preload'];

    if (preload === 'base') {
      return load().pipe(catchError(() => EMPTY));
    }

    if (preload !== 'menu' || this.tokenService.oneTimeTokenActive() || !this.tokenService.hasToken()) {
      return EMPTY;
    }

    const requiredMenuType = route.data?.['requiredMenuType'] as SettingsMenuItemType | undefined;
    if (!requiredMenuType) {
      return EMPTY;
    }

    return this.injector.get(NavService).hasUserMenuAccess(requiredMenuType).pipe(
      switchMap((hasAccess) => hasAccess ? load() : EMPTY),
      catchError(() => EMPTY)
    );
  }
}
